import type { AgentId } from '@quintessence/core';
import { PERSONAS } from '@quintessence/core';
import { SERIES } from '../theme';
import { AgentIcon } from './icons';

/** Round badge carrying the agent's line icon, lit faintly in its element colour, with a small dot in its series colour. */
export function AgentAvatar({ id, size = 44 }: { id: AgentId; size?: number; pulse?: boolean }) {
  return (
    <span className="avatar" style={{ width: size, height: size, ['--agent' as string]: SERIES[id] }} role="img" aria-label={PERSONAS[id].name}>
      <AgentIcon id={id} size={Math.round(size * 0.44)} />
    </span>
  );
}
